export const Marquee = ({ items, reverse = false, className = '', itemClassName = '', duration = 40, testid = 'marquee' }) => {
  const row = [...items, ...items];
  return (
    <div data-testid={testid} className={`overflow-hidden whitespace-nowrap ${className}`}>
      <div
        className={`inline-flex items-center will-change-transform ${reverse ? 'animate-marquee-reverse' : 'animate-marquee'}`}
        style={{ animationDuration: `${duration}s` }}
      >
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={i} className={`flex items-center shrink-0 ${itemClassName}`}>
                <span>{item}</span>
                <span className="mx-8 opacity-40">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
